import { Component, OnInit } from "@angular/core";
import { PublicService } from "../services/public.service";
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { ToasterService } from "../services/toaster.service";

import { RouterModule } from "@angular/router";

@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.css"],
  imports: [ReactiveFormsModule, RouterModule]
})
export class FooterComponent implements OnInit {
  subscribeForm: FormGroup;
  submitted = false;
  userEmail: string;
  loader = false;
  year=new Date().getFullYear();

  constructor(
    private publicService: PublicService,
    private formBuilder: FormBuilder,
    private toaster: ToasterService
  ) {}

  ngOnInit() {
    this.subscribeForm = this.formBuilder.group({
       email: [
        "",
        [
          Validators.required,
          Validators.pattern(
            "^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,9}$"
          ),
        ],
      ]
    });
  }

  //for convience easy access to form fields
  get c() {
    return this.subscribeForm.controls;
  }

  onSubmit() {
    this.submitted = true;
    this.userEmail = this.subscribeForm.controls.email.value;
    if (this.subscribeForm.controls.email.value == "") {
      this.toaster.show(
        "error",
        "Check it out!",
        "You need to enter your email address to subscribe"
      );

      return;
    }
    if (this.userEmail) {
      let match = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
      if (!match.test(this.userEmail)) {
        this.toaster.show(
          "error",
          "Check it out!",
          "This Email address is invalid"
        );
        return;
      }
    }
    if (this.subscribeForm.invalid) {
      return;
    }
    this.loader = true;
    this.publicService.isVerified(this.userEmail, 'subscriber').subscribe(
      (res: any) => {
        if (res.status === "Valid" || res.status === "RoleBased") {
          this.addSubscriber();
        } else {
          this.loader = false;
          this.toaster.show(
            "error",
            "Check it out!",
            "Your email address is not valid"
          );
        }
      },
      (err) => {
        this.loader = false;
        if (err.status === 429) {
          this.toaster.show("error", "Check it out!", err.error);
        } else {
          this.toaster.show(
            "error",
            "Check it out!",
            "Something went wrong"
          );
        }
      }
    );
  }

  addSubscriber() {
    let emailObj = {
      email: this.userEmail,
    };
    this.publicService.addSubscriber(emailObj).subscribe(
      (res: any) => {
        this.loader = false;
        if (res.data.status === "Unconfirmed") {
          this.toaster.show(
            "success",
            "Well done!",
            "Please check your email for verification link"
          );
        }
        if (res.data.status === "Active") {
          this.toaster.show(
            "success",
            "Well done!",
            "You are already a subscriber"
          );
        }
      },
      (err) => {
        this.loader = false;
        this.toaster.show(
          "error",
          "Check it out!",
          "Something went wrong"
        );
      }
    );
  }

  emailInput(){
    this.subscribeForm.controls.email.markAsUntouched();
  }
}
